// Import Bootstrap 5
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

// Import Alpine.js
import Alpine from 'alpinejs';
window.Alpine = Alpine;
Alpine.start();

// Import AOS
import AOS from 'aos';
window.AOS = AOS;

// Import Swiper
import Swiper from 'swiper/bundle';
window.Swiper = Swiper;

// Import GLightbox
import GLightbox from 'glightbox';
window.GLightbox = GLightbox;

// DOMContentLoaded
document.addEventListener('DOMContentLoaded', function () {
    // 1. Preloader fade out
    const preloader = document.getElementById('preloader');
    if (preloader) {
        setTimeout(() => {
            preloader.classList.add('loaded');
        }, 500);
    }

    // 2. Initialize AOS
    AOS.init({
        duration: 600,
        easing: 'ease-out-cubic',
        once: true,
        mirror: false,
        offset: 0, // trigger immediately when it enters viewport
        disable: false // ensure animations work everywhere
    });

    // 3. Sticky Navbar
    const navbar = document.querySelector('.navbar-custom');
    if (navbar) {
        window.addEventListener('scroll', () => {
            if (window.scrollY > 50) {
                navbar.classList.add('scrolled');
            } else {
                navbar.classList.remove('scrolled');
            }
        });
    }

    // 4. Initialize GLightbox
    const lightbox = GLightbox({
        selector: '.glightbox'
    });

    // 5. Initialize Swiper for Hero
    if (document.querySelector('.hero-swiper')) {
        new Swiper('.hero-swiper', {
            loop: true,
            effect: 'fade',
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });
    }

    // 6. Initialize Swiper for Teachers
    if (document.querySelector('.teachers-swiper')) {
        new Swiper('.teachers-swiper', {
            slidesPerView: 1,
            spaceBetween: 30,
            loop: true,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            breakpoints: {
                640: { slidesPerView: 2 },
                768: { slidesPerView: 3 },
                1024: { slidesPerView: 4 },
            }
        });
    }
});

// Refresh AOS when all images and resources have fully loaded
// This prevents elements at the bottom of the page from triggering late due to images pushing them down
window.addEventListener('load', function() {
    AOS.refresh();
});
